export class RedirectBrokerError extends Error {
    static unableToDetermineRedirect(message: string): RedirectBrokerError {
        const fullMessage = `Unable to determine redirect. ${message}`;
        return new RedirectBrokerError(fullMessage);
    }
}
